/**
 * File custom.js.
 */

(function ($) {
	'use strict';

function getNaturalHeight(element) {
    // Save the current max-height
    const previousMaxHeight = element.style.maxHeight;

    // Temporarily remove max-height
    element.style.maxHeight = 'none';

    // Get the scrollHeight (full content height)
    const naturalHeight = element.scrollHeight;

    // Restore the original max-height
    element.style.maxHeight = previousMaxHeight;

    return naturalHeight;
}
$(window).on('resize', function () {
	if ($('.languages-list').length) {
		const div = document.querySelector('.languages-list');
		const height = getNaturalHeight(div);
    if (height >= 30) {
		  $('.more-languages').css('display', 'block');
    } else {
      $('.more-languages').css('display', 'none');
    }
	}
	const photoStyleHeights = $(".content-listing__photo-style .content-listing__item .button-block-a__two-tones-wrap").map(function() {
		return $(this).outerHeight(true);
	}).get();
	
	const photoStyleHeightsMax = Math.max.apply(null, photoStyleHeights);
	$(".content-listing__photo-style .content-listing__item .button-block-a__two-tones-icon").css("height", photoStyleHeightsMax);
	
	const twoTonesHeights = $(".content-listing__two-tones-style .content-listing__item .button-block-a__two-tones-text").map(function() {
		return $(this).outerHeight(true);
	}).get();
	
	const twoTonesHeightsMax = Math.max.apply(null, twoTonesHeights);
	$(".content-listing__two-tones-style .content-listing__item .button-block-a__two-tones-text").css("height", twoTonesHeightsMax);
});

$(window).on('resize', function () {
	$('.site-header__bottom-bar ul.primary-menu > li > a').each(function () {
		const $link = $(this);
		const $parentLi = $link.parent('li'); // Get the parent <li>
		const lineHeight = parseInt($link.css('line-height'));
		const parentHeight = $parentLi.outerHeight();

		if (parentHeight <= lineHeight * 3.1) {
			$link.css({
			display: 'flex',
			alignItems: 'center',
			});
		} else {
			$link.css({
				alignItems: 'flex-start', // Reset or adjust alignment
			});
		}
	});
});

$(document).ready(function () {
	$('[data-bs-toggle="tooltip"]').tooltip();  

	if ($('.languages-list').length) {
		const div = document.querySelector('.languages-list');
		const height = getNaturalHeight(div);
    if (height >= 30) {
		  $('.more-languages').css('display', 'block');
		} else {
		  $('.more-languages').css('display', 'none');
    }
	}
	$( ".btn" ).each(function( index ) {
		let leftIcon = $(this).attr('data-button-left-icon') ? $(this).attr('data-button-left-icon') : '';
		let rightIcon = $(this).attr('data-button-right-icon') ? $(this).attr('data-button-right-icon') : '';
		if ( leftIcon ) {
			$( this ).prepend('<i class="button-icon-left '+ leftIcon +'"></i>');
		}
		if ( rightIcon ) {
			$( this ).append('<i class="button-icon-right '+ rightIcon +'"></i>');
		}

		let leftSVGIcon = $(this).attr('data-button-left-svg-icon') ? $(this).attr('data-button-left-svg-icon') : '';
		let rightSVGIcon = $(this).attr('data-button-right-svg-icon') ? $(this).attr('data-button-right-svg-icon') : '';
		if ( leftSVGIcon ) {
			let leftSVGIconClass = $(this).attr('data-left-icon') ? $(this).attr('data-left-icon') : '';
			if ( leftSVGIconClass ) {
				$( this ).prepend('<img src="'+leftSVGIcon+'" class="button-icon-left button-icon-left-img button-left-icon-'+leftSVGIconClass+'" alt="Button Left Icon" width="30" height="30" aria-hidden="true">');
			}
		}
		if ( rightSVGIcon ) {
			let rightSVGIconClass = $(this).attr('data-right-icon') ? $(this).attr('data-right-icon') : '';
			if ( rightSVGIconClass ) {
				$( this ).append('<img src="'+rightSVGIcon+'" class="button-icon-right button-icon-right-img button-right-icon-'+rightSVGIconClass+'" alt="Button Right Icon" width="30" height="30" aria-hidden="true">');
			}
		}
	});

	if ( $(".btn-social-share a.btn-social-share").length ) {
		const socialShareButton = document.querySelector('.btn-social-share a.btn-social-share');
		socialShareButton.addEventListener('click', event => {
			if ( navigator.share ) {
				let pageTitle = $('.btn-social-share a.btn-social-share').attr('data-page-title') ? $('.btn-social-share a').attr('data-page-title') : '';
				let pageLink = $('.btn-social-share a.btn-social-share').attr('data-page-link') ? $('.btn-social-share a').attr('data-page-link') : '';
				navigator.share({
					title: pageTitle,
					url: pageLink
				}).then(() => {
					console.log('Thanks for sharing!');
				}).catch(console.error);
			} else {
				$("#help-site-social-share").modal('show');
			}
		});
	}

	$(document).on('click', '#help-site-social-share .class-modal', function () {
		$("#help-site-social-share").modal('hide');
	});

	$( "body.rtl .btn" ).each(function( index ) {
		if ( $(this).find('.button-icon-right').hasClass('fa-angle-right') ) {
			$(this).find('.button-icon-right').removeClass('fa-angle-right');
			$(this).find('.button-icon-right').addClass('fa-angle-left');
		}

		if ( $(this).find('.button-icon-right').hasClass('bi-box-arrow-up-right') ) {
			$(this).find('.button-icon-right').removeClass('bi-box-arrow-up-right');
			$(this).find('.button-icon-right').addClass('bi-box-arrow-up-left');
		}
	});

	$( "body.rtl .button-block-a__item" ).each(function( index ) {
		if ( $(this).find('.button-icon-center').hasClass('bi-arrow-right-circle-fill') ) {
			$(this).find('.button-icon-center').removeClass('bi-arrow-right-circle-fill');
			$(this).find('.button-icon-center').addClass('bi-arrow-left-circle-fill');
		}
	});

	$( "body.rtl .content-listing__item" ).each(function( index ) {
		if ( $(this).find('.button-icon-center').hasClass('bi-arrow-right-circle-fill') ) {
			$(this).find('.button-icon-center').removeClass('bi-arrow-right-circle-fill');
			$(this).find('.button-icon-center').addClass('bi-arrow-left-circle-fill');
		}
	});

	$('body.rtl .button-icon-right-img').each(function () {
		const $img = $(this);
		const src = $img.attr('src');

		// Replace "Right_Arrow.svg" with "Left_Arrow.svg"
		const updatedSrc = src.replace('Right_Arrow.svg', 'Left_Arrow.svg');

		$img.attr('src', updatedSrc);
	});

	$('.q-and-a .accordion').on('shown.bs.collapse', function (e) {
		var headerHeight = $('.site-header').outerHeight() + 65; // Adjust selector as needed
		$('html, body').animate({
			scrollTop: $(e.target).offset().top - headerHeight
		}, 500);
	});


	$(document).on('click', '.site-header__bottom-left', function () {
		$('.site-header__bottom-bar ul.primary-menu > li > a').each(function () {
			const $link = $(this);
			const $parentLi = $link.parent('li'); // Get the parent <li>
			const lineHeight = parseInt($link.css('line-height'));
			const parentHeight = $parentLi.outerHeight();

			if (parentHeight <= lineHeight * 3) {
				$link.css({
				display: 'flex',
				alignItems: 'center',
				});
			} else {
				$link.css({
					alignItems: 'flex-start', // Reset or adjust alignment
				});
			}
		});
	});
   

    $("html").css("scroll-padding-top", $('#masthead').height());

		$('.search-form').submit(function (e) {
            // Get the value from the search input field

            let searchValue = $(this).parent().find('.search-field').val();
            // Check if the search value has at least 3 characters
            if (searchValue.length < 3) {
                // Prevent the form from submitting
                e.preventDefault();

                // Insert the error message dynamically
                $(this).parents( '.search-form-wrapper' ).find('.error-message').show();
            } else {
                // Clear any previous error messages
                $(this).parents( '.search-form-wrapper' ).find('.error-message').hide();
            }
		});

		// Popup clicking by ID
		$(document).on("click", ".marketing-site-main a, .site-main a", function () {
			let getURL     = $(this).attr('href');
			let getPopupId = getURL.replace('##', '.');

			if ( getPopupId !== '' && getPopupId !== '.' && getURL.indexOf('##') !== -1 ) { 
				$(getPopupId).click();
				return false;
			}
		});

		//add target blank wherever in site found a tag with pdf
		// Get all anchor tags
		var anchorTags = document.querySelectorAll('a');
	
		// Iterate through each anchor tag
		anchorTags.forEach(function (anchor) {
			// Check if href ends with '.pdf' and target="_blank" doesn't exist
			if (
			anchor.getAttribute('href') &&
			anchor.getAttribute('href').toLowerCase().endsWith('.pdf') &&
			!anchor.getAttribute('target')
			) {
			// Add target="_blank" attribute
			anchor.setAttribute('target', '_blank');
			}
		});

        const photoStyleHeights = $(".content-listing__photo-style .content-listing__item .button-block-a__two-tones-wrap").map(function() {
            return $(this).outerHeight(true);
        }).get();
        
        const photoStyleHeightsMax = Math.max.apply(null, photoStyleHeights);
        $(".content-listing__photo-style .content-listing__item .button-block-a__two-tones-icon").css("height", photoStyleHeightsMax);

		const twoTonesHeights = $(".content-listing__two-tones-style .content-listing__item .button-block-a__two-tones-text").map(function() {
			return $(this).outerHeight(true);
		}).get();
		
		const twoTonesHeightsMax = Math.max.apply(null, twoTonesHeights);
		$(".content-listing__two-tones-style .content-listing__item .button-block-a__two-tones-text").css("height", twoTonesHeightsMax);
	});

})(jQuery);
